import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthSessionService } from 'core/services/auth-session.service';
import { CanteenService } from 'core/services/canteen.service';

/**
 * Após OneAuth, habilita o contexto operacional mock (menus/PDV).
 * A identidade exibida no header/perfil continua sendo a conta real.
 */
export const canteenShellGuard: CanActivateFn = () => {
  const auth = inject(AuthSessionService);
  const canteen = inject(CanteenService);

  if (auth.isAuthenticated() && !canteen.signedIn()) {
    canteen.signIn('usr-admin');
  }

  return true;
};
